module.exports = __webpack_public_path__ + "img/true.dbad45af.png";